export default "__VITE_ASSET__514e0994__"